// extracted by mini-css-extract-plugin
module.exports = {"blogCard":"Blog_blogCard__3eHI0","blogCardBody":"Blog_blogCardBody__2B1Ik"};